import { render, staticRenderFns } from "./memberShareWithdrawTrx.vue?vue&type=template&id=47930fa2&scoped=true"
import script from "./memberShareWithdrawTrx.vue?vue&type=script&lang=js"
export * from "./memberShareWithdrawTrx.vue?vue&type=script&lang=js"
import style0 from "./memberShareWithdrawTrx.vue?vue&type=style&index=0&id=47930fa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47930fa2",
  null
  
)

export default component.exports